// extracted by mini-css-extract-plugin
module.exports = {"InvestmentLocationsPage":"InvestmentLocationsPage-module__InvestmentLocationsPage___2zPbb"};